// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__QwKfr","head":"Table_head__1h6Dm","col":"Table_col__2iVF3"};